<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Cadastro de Chave de API</strong>
        </div>
        <b-form @submit.stop.prevent>
        <fieldset class="form-group">
          <legend class="col-form-label pt-0">Corporação: <strong>{{appData.corporation}}</strong></legend>
        </fieldset>

        <fieldset class="form-group">
          <legend class="col-form-label pt-0">Aplicação: <strong>{{appData.client}}</strong></legend>
        </fieldset>

        <fieldset class="form-group">
          <legend class="col-form-label pt-0">Ambiente: <strong>{{appData.env}}</strong></legend>
        </fieldset>

        <fieldset class="form-group" v-if="!appData.key">
          <legend class="col-form-label pt-0"><strong>A chave de API não foi gerada.</strong></legend>
        </fieldset>

        <fieldset class="form-group" v-if="appData.key">
          <legend class="col-form-label pt-0">Chave de API: <strong>{{appData.key}}</strong></legend>
        </fieldset>

        <fieldset class="form-group" v-if="appData.url">
          <legend class="col-form-label pt-0">URL de autenticação: <a :href="appData.url" target="_blank">{{appData.url}}</a></legend>
        </fieldset>
                
        <div slot="footer">
          <b-row>
            <b-col sm="12" lg="2" v-if="!appData.key">
              <b-button class="form-control" type="submit" variant="primary" @click="generate"><i class="fa fa-dot-circle-o"></i> Gerar Chave</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2" v-if="appData.key">
              <b-button class="form-control" type="button" variant="danger" @click="revoke()"><i class="fa fa-remove"></i> Revogar Chave</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="button" variant="secondary" @click="goBack"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
            </b-col>
          </b-row>
        </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate, isAllowed } from '@/shared/utils';
import _ from 'underscore';
import { mapActions } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Corporation',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Chave de API'
    }
  },
  data: () => {
    return {
      loadCount: 0,
      id: '',
      appData: {}
    }
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.appData = this.$route.query;
    let apiKey = await this.getApiKey();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    async getApiKey() {
      this.loadCount++;
      try {
        let response = await axios.get(`${env.urlBillingApi}/api-key/${this.id}`);
        if (response.data) {
          this.appData.key = response.data.token;
          this.appData.url = response.data.url;
        }
      } catch (error) {
        requestError(error);
      } finally {
        this.loadCount--;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async generate() {
      this.loadCount++;
      try {
        let response = await axios.post(`${env.urlBillingApi}/api-key`, { application_id: this.id });
        if (response.data) {
          this.appData.key = response.data.token;
          this.appData.url = response.data.url;
        }
      } catch (error) {
        requestError(error);
      } finally {
        this.loadCount--;
      }
    },
    async revoke(force = false) {
      if (!force) {
        let next = await this.$bvModal.msgBoxConfirm('Deseja realmente revogar a chave?', {
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        });
        if (!next) {
          return;
        }
      }
      this.loadCount++;
      try {
        await axios.delete(`${env.urlBillingApi}/api-key/${this.id}?force=${force ? 1 : 0}`);
        this.appData.key = null;
        this.appData.url = null;
        this.loadCount--;
      } catch (error) {
        this.loadCount--;
        let status = error.response && error.response.status;
        let message = error.response && error.response.data && error.response.data.detail && error.response.data.detail.detail && error.response.data.detail.detail.message;
        if (status == 400) {
          let next = await this.$bvModal.msgBoxConfirm(`Houve um erro na integração com o HUB: "${message}". Deseja forçar a remoção do token?`, {
            okVariant: 'danger',
            okTitle: 'Sim',
            cancelTitle: 'Não',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          });
          if (!next) {
            return;
          }
          return this.revoke(true);
        }
        requestError(error);
      }
    }
  }
}
</script>

<style scoped>
.clientID {
  font-size: 16px;
}
@media (min-width: 576px) {
  /* .card-body >>> .card-list {
    max-width: 200px;
  } */
}
</style>